import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'index',
    component: () => import("@/views/index"),
    redirect: "/home",
    children: [
      {
        path: '/home',
        name: 'home',
        component: () => import('@/views/home/index')
      },
      {
        path: '/page',
        name: 'page',
        component: () => import('@/views/page/index'),
        redirect: "/companyData",
        children: [
          {
            path: '/companyData',
            name: 'companyData',
            component: () => import('@/views/companyData/index')
          },
          {
            path: '/chemicalsData',
            name: 'chemicalsData',
            component: () => import('@/views/chemicalsData/index')
          },
          {
            path: '/chemicalsQrCode',
            name: 'chemicalsQrCode',
            component: () => import('@/views/chemicalsQrCode/index')
          },
          {
            path: '/knowledgeGraph',
            name: 'knowledgeGraph',
            component: () => import('@/views/knowledgeGraph/index')
          },
          {
            path: '/trainingBase',
            name: 'trainingBase',
            component: () => import('@/views/trainingBase/index')
          },
          {
            path: '/gardenOfKnowledge',
            name: 'gardenOfKnowledge',
            component: () => import('@/views/gardenOfKnowledge/index')
          },
          {
            path: '/news',
            name: 'news',
            component: () => import('@/views/news/index')
          },
          {
            path: '/messageBoard',
            name: 'messageBoard',
            component: () => import('@/views/messageBoard/index')
          },
        ],
      },

      {
        path: '/newsDetail',
        name: 'newsDetail',
        component: () => import('@/views/newsDetail/index')
      },

    ],
  },
]

const router = new VueRouter({
  mode: 'history',
  base: 'publicInternet',
  routes
})

export default router
